import { Quotation } from '../../../../../sale/model';
import { Menu, Constants, isMobile } from '../../../../../core';
import { IconsOfActions } from '../../data-table.interface';
import { environment } from '../../../../../../environments/environment';

export const icons: IconsOfActions[] = [
  {
    icon: 'cancel',
    tooltip: 'Cancelar',
    hasVisibleCondition: (element: Quotation[]): boolean => {
      return true;
    }
  },
  {
    icon: 'approved',
    tooltip: 'Aprobar',
    hasVisibleCondition: (element: Quotation[]): boolean => {
      return true;
    }
  },
  {
    icon: 'printer',
    tooltip: 'Imprimir',
    hasVisibleCondition: (element: Quotation[]): boolean => {
      if (element.length >= 2) {
        return false;
      }
      const printable = Constants.ConfigQuotation.STATE_QUOTATION.getProps()
        .find(item => item.value.includes(element[0].quotationInfo.stateId)).printable;
      return printable;
    }
  }
];
export const searchQuotationInfo = {
  paginator: true,
  checkbox: true,
  iconsOfActions: icons,
  alterColumns: true,
  exportAllData: true,
  expandable: true,
  exportFile: 'cotizaciones.xlsx',
  currency: () => {
    const user = JSON.parse(localStorage.getItem(environment.sessionAuth));
    return user ? user.user.currencyCode : '';
  },
  hasDisabledCheckBoxItem: (row: Quotation): boolean => {
    /**
     * Si es cancelada o pagada
     */
    return row.quotationInfo.cancellable ? false : row.quotationInfo.stateId === Constants.ConfigQuotation.STATE_QUOTATION.PAYED ? false : true;
  },
  expandingValidation: (row: any): boolean => {
    if ( row.quotationInfo.findAssociatedQuotations && row.quotationInfo.associatedQuotations && row.quotationInfo.associatedQuotations.length > 0) {
      return true;
    } else {
      return false;
    }
  },
  show: 'Aplicar los filtros para ver los resultados',
  columns: [
    {
      title: 'Nro cotización',
      name: 'quotationNumber',
      type: 'string',
      checkAll: false,
      editable: false,
      visible: true,
      mandatory: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.quotationNumber
    },
    {
      title: 'Nota de venta',
      name: 'orderEanCode',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: false,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo ? element.quotationInfo.orderEanCode : ''
    },
    {
      title: 'Estado',
      name: 'origin',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.state.capitalize()
    },
    {
      title: 'Fecha de creación',
      name: 'date',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.dateCreated
    },
    {
      title: 'Fecha de modificación',
      name: 'availableItems',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.lastUpdated
    },
    {
      title: 'Tienda de venta',
      name: 'destination',
      type: 'string',
      editable: false,
      checkAll: false,
      mandatory: true,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.saleEntity ? element.quotationInfo.saleEntity.toUpperCase() : ''
    },
    {
      title: 'Cotizador',
      name: 'Cotizador',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.username
    },
    {
      title: 'Doc. identidad',
      name: 'documentNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.documentNumber
    },
    {
      title: 'Método de pago',
      name: 'paymentMethod',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'left',
      value: (element: Quotation) => element.quotationInfo.paymentMethod
    },
    {
      title: 'Tipo de cotización',
      name: 'transactionType',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'right',
      value: (element: Quotation) => element.quotationInfo.transactionType
    },
    {
      title: 'Monto',
      name: 'price',
      type: 'string',
      editable: false,
      checkAll: false,
      visible: true,
      class: 'right',
      value: (element: Quotation) => `${searchQuotationInfo.currency()}/${element.quotationInfo.totalAmount}`
    },
    {
      title: '',
      name: 'stateDispatch',
      type: 'editableColumns',
      visible: isMobile() ? false : true,
      editable: true,
      checkAll: true,
      class: 'width-none left',
      value: (element: Quotation, currentMenu: Menu) => {
        return {
          url: currentMenu.link + '/cotizacion/' + element.quotationInfo.quotationNumber,
          icon: 'keyboard_arrow_right',
          class: 'recordColumn icon-table'
        };
      }
    }
  ]
};
